import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Checkbox, Link } from "@mui/material";
import "../EmailComponent/EmailComponent.scss";
import CheckBox from "../../../Supporting files/CheckBox/CheckBox";

interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const EmailComponent: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const [emailData, setEmailData] = React.useState([
    {
      checkbox_status: true,
      check_status: "",
      sender_person_tag: "",
      from_person: "",
      email_subject: "",
      recipients: "",
      date: "",
      time: "",
      action_btn1: "",
      action_btn2: "",
    },
  ]);

  useEffect(() => {
    setEmailData([
      {
        checkbox_status: false,
        check_status: "",
        sender_person_tag: "AS",
        from_person: "Ankit Sachdeva",
        email_subject: "Automation Enhancements and ...",
        recipients: "Umesh Gemini, Karan Joshi",
        date: "23 Dec, 2022",
        time: "11:00 AM",
        action_btn1: "images/email_attachment_icon.svg",
        action_btn2: "images/email_action_icon.svg",
      },
      {
        checkbox_status: false,
        check_status: "",
        sender_person_tag: "RR",
        from_person: "Rahul Raghuvanshi",
        email_subject: "Automation Enhancements and ...",
        recipients: "Umesh Gemini, Karan Joshi",
        date: "23 Dec, 2022",
        time: "11:00 AM",
        action_btn1: "images/email_attachment_icon.svg",
        action_btn2: "images/email_action_icon.svg",
      },
    ]);
  }, []);

  const updateMasterStateArray = (attrName: any, value: any) => {
    if (attrName[2] === "value") {
      console.log(attrName, value);
    } else if (attrName[1] === "checkbox_status") {
      let data = emailData;
      data[attrName[0]].checkbox_status = !data[attrName[0]].checkbox_status;
      setEmailData(data);
      console.log(data);
    }
  };

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <div className="table">
            <div className="renewal-table2">
              <ul className="heading">
                <li>From</li>
                <li>Subject</li>
                <li>Cc,Bcc</li>
                <li>Date</li>
                <li>Time</li>
                <li>Attatchment</li>
              </ul>

              {emailData.map((data, index) => (
                <ul className="subheading">
                  <li>
                    <div className="Checkbox">
                      <input type="checkbox" name="check" />
                      <label className="employee"></label>
                    </div>
                    <Link
                      className="sender_name"
                      onClick={() => {
                        // setOpenEmail(true);
                      }}
                    >
                      <span>{data.sender_person_tag}</span>
                      {data.from_person}
                    </Link>
                  </li>
                  <li>
                    <p className="subject"> {data.email_subject}</p>
                  </li>
                  <li>
                    Cc:
                    <span className="cc">{data.recipients}</span>
                  </li>
                  <li>
                    <p className="date_time">{data.date}</p>
                  </li>
                  <li>
                    <p className="time">{data.time}</p>
                  </li>
                  <li>
                    <Link className="attatchment">
                      <Link>
                        <img src="./images/attatch_icon.svg" alt="" />
                      </Link>
                      <Link className="ml-2">
                        <img src="./images/share_icon.svg" alt="" />
                      </Link>
                    </Link>
                  </li>
                </ul>
              ))}
            </div>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmailComponent;
